import { render } from "./StationCollection.vue?vue&type=template&id=f9ef5e9c&scoped=true"
import script from "./StationCollection.vue?vue&type=script&lang=js"
export * from "./StationCollection.vue?vue&type=script&lang=js"

import "./StationCollection.vue?vue&type=style&index=0&id=f9ef5e9c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ef5e9c"]])

export default __exports__